'use client'

import * as React from "react";
import { usePathname } from 'next/navigation';

import { i18n, getLocaleName } from '../../../i18n-config';

import { Dropdown, DropdownTrigger, DropdownMenu, DropdownItem, Badge,  Button } from "@nextui-org/react";

import { Link } from "@nextui-org/link";
import { TranslateIcon } from "@/app/[lang]/components/icons";

// import { Fontdiner_Swanky } from "next/font/google";

export default function LocaleSwitcher() {
  const pathName = usePathname();
  
  const getLocale = () => {
    if (!pathName) return '';
    const segments = pathName.split('/');
    return segments[1];
  }

  const redirectedPathName = (locale: string) => {
    if (!pathName) return '/'
    const segments = pathName.split('/')
    segments[1] = locale
    return segments.join('/')
  }

  const selectedLocale = getLocale();

  return (
    <>
    <Badge color="default" shape="rectangle" size="sm" content={selectedLocale} variant="shadow"  >
    <Dropdown>
      <DropdownTrigger>        
          <Button
            // radius="full"
            isIconOnly
            aria-label="selected-locale"
            variant="bordered"
            title={getLocaleName(selectedLocale as any)}
          >
            <TranslateIcon size={24} className="text-default-500" />
          </Button>          
      </DropdownTrigger>
      <DropdownMenu aria-label="Localization items" variant="shadow">
        {i18n.locales.map((locale) => {
            return (
                <DropdownItem key={locale}>
                    <Link 
                        className= { selectedLocale === locale ? 'text-sm w-full font-bold': 'text-sm w-full font-normal' }
                        href={redirectedPathName(locale)}
                        color="foreground"
                    > {getLocaleName(locale)}
                    </Link>
                </DropdownItem>
            )
        })}
      </DropdownMenu>
    </Dropdown>
        </Badge>
        
    </>    
  )
}